import {licencia, filtros} from './state';

export function establecerLicencias(state, licencias) {
  state.licencias = licencias;
}

export function establecerLicencia(state, licencia) {
  state.licencia = licencia;
}

export function resetLicencia(state) {
  state.licencia = licencia();
}

export function establecerAccion(state, accion) {
  state.accion = accion;
}

export function establecerModalVer(state, ver) {
  state.modal.ver = ver;
}

export function resetFiltros(state) {
  state.filtros = filtros();
}

export function establerIdEmpresaFiltros(state, id_empresa) {
  state.filtros.id_empresa = id_empresa;
}

export function establerIdEmpresaLicencia(state, id_empresa) {
  state.licencia.id_empresa = id_empresa;
}

export function establerFechasLicencia(state) {
  state.licencia.fecha_inicio = state.licencia.fechas[0];
  state.licencia.fecha_fin = state.licencia.fechas[1];
}

export function establecerEmpresas(state, empresas) {
  state.empresas = empresas;
}

//Mutación para llegar arreglo con formas de pago , útil para ser usado en un select
export function establecerFormasDePago(state, modalidades) {
  state.modalidades = modalidades;
}

/**
 * Asignar datos a la varible de responsables.
 * 
 * @param {*} state 
 * @param {*} responsibles 
 * @author Fernando CLaros Garcia
 */
export function setResponsibles(state, responsibles) {
  state.responsibles = responsibles;
}

/**
 * Asignar datos al modal activo para aceptacion de la licencia.
 * 
 * @param {*} state 
 * @param {*} modal 
 * @author Fernando CLaros Garcia
 */
export function setModalAcceptLicense(state, modal) {
  state.modalAcceptLicense.isOpen = modal;
}

/**
 * Asignar datos al modal activo para detalles de la licencia.
 * 
 * @param {*} state 
 * @param {*} modal 
 * @author Fernando CLaros Garcia
 */
export function setModalDetailsLicence(state, modal) {
  state.modalDetailsLicense.isOpen = modal;
}

/**
 * Asignar datos para las modalidaes de pago en la seccion de aceptar licencia por el responsable.
 * 
 * @param {*} state 
 * @param {*} paymentMethods 
 * @author Fernando CLaros Garcia
 */
export function setPaymentMethods(state, paymentMethods) {
  state.paymentMethods = paymentMethods;
}

/**
 * Identificar cual de las tab de licencias esta activa.
 * 
 * Tabs posibles: 
 * (license-history): historial de licencias.
 * (Licensing-contract): Contrato de licenciamiento para el uso de Soluquim.
 * 
 * @param {*} state 
 * @param {*} tabActive: tab que esta activa
 * @author Fernando CLaros Garcia
 */
export function setTabActive(state, tabActive) {
  state.tabActive = tabActive;
}

/**
 * Ver detalles del texto del contrato.
 *  * 
 * @param {*} state 
 * @param {*} isVisibleDetailsLicensingContract: true: ver detalles del texto del contrato, false: no
 * @author Fernando CLaros Garcia
 */
export function setIsVisibleDetailsLicensingContract(state, isVisibleDetailsLicensingContract) {
  state.isVisibleDetailsLicensingContract = isVisibleDetailsLicensingContract;
}
